module.exports = __webpack_public_path__ + "static/img/daoruyunshu.e38c93f9.png";